import { InputErrorTemplate } from '@core/errors/error-template';
import { EmailValidator, FirebaseAuthValidator, NetworkErrorValidator } from '@core/errors/generic-errors';
import { Inject } from '@rxdi/core';
import { Form, FormGroup } from '@rxdi/forms';
import { Component, css, html, LitElement, property } from '@rxdi/lit-html';
import { InputStyle } from '@rxdi/ui-kit/styles/form/input';
import { SocialService } from '@stradivario/graphql-server';

import { ResetPasswordModel } from './reset-password.model';

/**
 * @customElement reset-password-component
 */
@Component({
  selector: 'reset-password-component',
  styles: [
    InputStyle,
    css`
      .container {
        padding: 50px;
        margin: 0px auto;
        margin-top: 150px;
        width: 600px;
        background-color: var(--global-background, #282d32);
        border: 1px solid #3c3c3c;
        border-radius: 15px;
        box-shadow: rgba(162, 162, 162, 0.25) 0px 0px 3px, rgba(0, 0, 0, 0.22) 0px 0px 3px;
      }

      .is-invalid {
        box-shadow: 0 0 1px 1px #c95454;
      }

      p {
        margin: 0px;
      }
    `,
  ],
  template(this: ResetPasswordComponent) {
    return html`
      <div class="container">
        <div class="form-group card card-container">
          ${this.emailSend
            ? html`
                <div style="text-align: center;">
                  <p>Success send email to address ${this.form.value.email}</p>
                </div>
              `
            : html`
                <div style="text-align: center;">
                  <p style="font-weight: 400;font-size: 2em;margin-bottom: 20px;">Forgot password ?</p>
                  <p>Enter the email address associated with your account.</p>
                </div>
                <form
                  name="register-form"
                  class="form-signin ${!this.form.valid ? 'has-error' : ''}"
                  novalidate
                  @submit=${() => !this.hasErrors() && this.onSubmit()}
                >
                  <p>Email</p>
                  <input name="email" type="email" class="rx-input" placeholder="Email address" required autofocus />
                  ${InputErrorTemplate(this.form.get('email'))}
                  <div style="height:30px"></div>
                  <rx-button
                    style="width:100%"
                    palette="primary"
                    class="btn btn-lg btn-primary btn-block btn-signin"
                    type="submit"
                  >
                    Reset password
                  </rx-button>
                </form>
              `}
        </div>
      </div>
    `;
  },
})
export class ResetPasswordComponent extends LitElement {
  @Inject(SocialService) private socialService: SocialService;
  @property({ type: Boolean }) private emailSend: boolean;
  model: ResetPasswordModel = new ResetPasswordModel();
  error: unknown;
  @Form({
    strategy: 'input',
    name: 'register-form',
    strict: true,
  })
  private form = new FormGroup<ResetPasswordModel>({
    email: [this.model.email, [NetworkErrorValidator, EmailValidator, FirebaseAuthValidator]] as never,
  });

  onSubmit() {
    this.socialService.resetPassword(this.form.value.email).subscribe(
      () => {
        this.emailSend = true;
      },
      (e) => {
        this.error = e;
      }
    );
  }

  async hasErrors() {
    return (await this.form.updateValueAndValidity()).length;
  }
}
